import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { RouterLink } from "src/components/router-link";
import { Box, Link, useTheme } from "@mui/material";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
  },
  paper: {
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    minWidth: "min-content",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // background: "#fff",
    maxWidth: "512px",
    marginRight: "auto",
    marginLeft: "auto",
  },
  innerPaper: {
    padding: "16px",
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    maxWidth: "120px",
    // width: "100%",
    height: "50px",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  },
  checkIcon: {
    fontSize: "6rem",
    color: "#22C55E",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    background: `linear-gradient(to right, #417FF6, #A557F7)`,
    WebkitBackgroundClip: "text",
    color: "transparent",
  },
  content: {
    textAlign: "center",
    paddingBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(0),
    backgroundColor: "#5762FD",
    color: "#fff",
    borderRadius: "999px",
    "&:hover": {
      backgroundColor: "#5762FD",
    },
  },
  buttonIcon: {
    fontSize: "1.5rem",
  },
}));

function ThankYou() {
  const classes = useStyles();
  const theme = useTheme();
  const {
    logoUrl,
    showCompanyName,
    companyName,
    primaryBrandColor,
    secondaryBrandColor,
  } = useContext(WhiteLabelConfigurationContext);
 

  return (
    <div className={classes.root}>
      <Container>
        <Paper
          elevation={0}
          style={{
            backgroundImage: `linear-gradient(to right,${primaryBrandColor}, ${secondaryBrandColor})`,
          }}
          className={classes.paper}
        >
          <Paper elevation={0} className={classes.innerPaper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "10px",
                gap: "10px",
              }}
            >
              <Box
                sx={{
                display: "inline-flex",
                height: 44,
                // width: 44,
                }}
                >
                <img src={logoUrl} alt="" className={classes.logo}/>
              </Box>
              <Typography variant="h4">{companyName}</Typography>
            </div>
            <AiOutlineCheckCircle className={classes.checkIcon} />
            <Typography
              variant="h1"
              style={{
                // background: `linear-gradient(to right, ${primaryBrandColor}, ${secondaryBrandColor})`,
                fontSize: "2.5rem",
                fontWeight: "bold",
                color: primaryBrandColor 
              }}
              // className={"thank-you-title"}
            >
              Thank You !
            </Typography>
            <Typography variant="body1" className={classes.content}>
              Thank you for your interest! Check your email for a link to the
              guide.
            </Typography>
            <Button
              component={RouterLink}
              href={"/auth-main/login/v2"}
              variant="contained"
              // className={classes.button}
              style={{
                margin: theme.spacing(0),
                "&:hover": {
                  backgroundColor: secondaryBrandColor,
                },
                backgroundColor: primaryBrandColor,
                fontSize: "14px",
                display: "flex",
                color: '#fff',
                alignItems: "center",
                gap: "4px",
              }}
              startIcon={
                <FaLongArrowAltLeft
                style={{
                  
                  color: '#fff',
                  fontSize: "14px",
                }}
              />
              }
            >
            
              Login
            </Button>
          </Paper>
        </Paper>
      </Container>
    </div>
  );
}

export default ThankYou;
